import tmhRequest from "@/config/tmhRequest";

export default {
  searchProductOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/searchproductorder",
      method: "post",
      params: data
    });
  },
  searchProductOrderCount: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/searchproductordercount",
      method: "post",
      data: data
    });
  },
  searchProductOrderByPage: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/searchproductorderbypage",
      method: "post",
      data: data
    });
  },

  initTargetStoreEmployee: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/inittargetstoreemployee",
      method: "post",
      params: data
    });
  },

  initTargetStoreMarket: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/inittargetstoremarket",
      method: "post",
      params: data
    });
  },

  createProductOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/createproductorder",
      method: "post",
      data: data
    });
  },

  initTargetCooperateMyCoupon: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/inittargetcooperatemycoupon",
      method: "post",
      data: data
    });
  },
  initTargetNormalMyCoupon: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/inittargetnormalmycoupon",
      method: "post",
      data: data
    });
  },
  initTargetDiscount: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/inittargetdiscount",
      method: "post",
      data: data
    });
  },


  initTargetMyCard: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/inittargetmycard",
      method: "post",
      params: data
    });
  },
  initTargetBalance: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/inittargetbalance",
      method: "post",
      params: data
    });
  },
  confirmProductOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/confirmproductorder",
      method: "post",
      data: data
    });
  },
  mixPayProductOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/mixpayproductorder",
      method: "post",
      data: data
    });
  },
  closeProductOrder: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/closeproductorder",
      method: "post",
      params: data
    });
  },
  searchListIspaProductOrder: function(data) {
    return tmhRequest({
      url: "/ispa/order/ispaproductorder/searchlistispaproductorder",
      method: "post",
      params: data
    });
  },

  transferProductOrder: function(data) {
    return tmhRequest({
      url: "/ispa/order/productorder/transferproductorder",
      method: "post",
      params: data
    });
  },

  repairEmployeePerformance: function(data) {
    return tmhRequest({
      url: "/order/ispa/productorder/repairemployeeperformance",
      method: "post",
      params: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/ispa/order/productorder.js